import React from 'react'

import Base from '../_Base'

const CustomList = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M22,17 L22,19 L6,19 L6,17 L22,17 Z M3,17 C3.55228475,17 4,17.4477153 4,18 C4,18.5522847 3.55228475,19 3,19 C2.44771525,19 2,18.5522847 2,18 C2,17.4477153 2.44771525,17 3,17 Z M22,11 L22,13 L6,13 L6,11 L22,11 Z M3,11 C3.55228475,11 4,11.4477153 4,12 C4,12.5522847 3.55228475,13 3,13 C2.44771525,13 2,12.5522847 2,12 C2,11.4477153 2.44771525,11 3,11 Z M22,5 L22,7 L6,7 L6,5 L22,5 Z M3,5 C3.55228475,5 4,5.44771525 4,6 C4,6.55228475 3.55228475,7 3,7 C2.44771525,7 2,6.55228475 2,6 C2,5.44771525 2.44771525,5 3,5 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default CustomList
